<template>
  <div class="section" style="min-height:320px">
    <div class="container content">
      <p class="title is-4">
        Все используемые в проекте иконки
      </p>
      <p>
        Можно подключить сканирования "всего" сайта Битрикс,
        но это неэффективно со всех точек зрения. Отслеживание
        файлов, диск и компиляция. По-умолчанию UnoCSS следит за
        потоком сборки в реальном времени, это все файлы подключенные
        в main.ts и только они. Так и должно оставаться.
      </p>
      <p>
        Это значит, что иконки добавленные в код других файлов не
        будут отображаться. UnoCSS обнаруживает классы и компилирует
        CSS-код. Чтобы классы иконок были добавлены, создан этот
        компонент, в нем должны размещаться все используемые иконки.
        Надо добавить соответствующий HTML-код. Сам компонент может
        не использоваться, важно только его наличие и подключение.
      </p>
      <p>
        Bulma, Oruga - не поддерживают svg-иконки, надо комбинировать
        собственные стили и подходы фреймворков. Для определения цвета,
        размера может потребоваться указание стилей сразу в элементе.
      </p>
      <p>
        В конечном итоге иконки - это css код, с внедренным
        svg-кодом. Можно увидеть в css файлах. Следует помнить, что
        этот код можно создать и вручную. Можно использовать svg
        напрямую в коде компонентов и страниц. UnoCSS лишь автоматизирует
        этот процесс и добавляет только используемые иконки.
      </p>
      <p class="title">Collection: Lucide, i-lucide-*</p>
      <div class="site-icons">
        <span class="icon">
          <i class="i-lucide-user" />
        </span>
      </div>
      <p class="title">Collection: Simple Icons, i-simple-icons-*</p>
      <div
        class="site-icons is-flex my-4"
        style="gap: 1rem;"
      >
        <span class="icon">
          <i
            class="
              i-simple-icons-whatsapp
              has-text-link
            "
            style="
              width: 64px;
              height: 64px;
            "
          />
        </span>
        <span class="icon">
          <i class="i-simple-icons-telegram" />
        </span>
        <span class="icon">
          <i class="i-simple-icons-vk" />
        </span>
        <span class="icon">
          <i class="i-simple-icons-vk" />
        </span>
        <span class="icon">
          <span class="i-lucide-map-pinned" />
        </span>
        <span class="icon">
          <span class="i-lucide-map-pin" />
        </span>
        <span class="icon">
          <span class="i-lucide-circle-check" />
        </span>
        <span class="icon">
          <span class="i-lucide-chevron-up" />
        </span>
        <span class="icon">
          <span class="i-lucide-chevron-down" />
        </span>
        <span class="icon">
          <span class="i-lucide-chevron-left" />
        </span>
        <span class="icon">
          <span class="i-lucide-arrow-left-to-line" />
        </span>
        <span class="icon">
          <span class="i-lucide-calendar-days" />
        </span>
        <span class="icon">
          <span class="i-lucide-eye" />
        </span>
        <span class="icon">
          <span class="i-lucide-type" />
        </span>
        <span class="icon">
          <span class="i-lucide-arrow-down"></span>
          <span class="i-lucide-arrow-up"></span>
          <span class="i-lucide-arrow-right"></span>
          <span class="i-lucide-star"></span>
          <span class="i-lucide-asterisk"></span>
          <span class="i-lucide-smartphone"></span>
        </span>
        <span class="icon">
          <span class="i-lucide-image"></span>
          <span class="i-lucide-image-off"></span>
          <span class="i-lucide-contrast"></span>
          <span class="i-lucide-person-standing"></span>
        </span>
      </div>
      <p class="title">Custom (i-custom-*)</p>
      <p>
        Собственные иконки добавляются как SVG файлы, по примеру
        уже подключенных коллекций. Иконки размещаются в
        <code>www/assets/icons/*.svg</code>. Имя иконки должно быть
        одним словом. Например, <code>car.svg</code>. Использование,
        <code>class="i-custom-car"</code>.
      </p>

      <span class="icon">
        <i
          class="i-custom-solar-box"
          style="width: 64px; height: 64px; color: red;"
        />
      </span>
    </div>
  </div>
</template>
